<template>
    <div class="approval-card" ref="rootEl">
        <div class="panel-header">
            <div class="panel-title">事项办理</div>
            <!-- 状态标签 -->
            <div class="header-tabs">
                <a-button
                    v-for="tab in todoTagOptions"
                    :key="tab.value"
                    :size="buttonSize"
                    :type="activeTodoTag === tab.value ? 'primary' : 'default'"
                    @click="setTodoTag(tab)"
                >
                    {{ tab.name }}
                </a-button>
            </div>
            <a class="text-link" @click="handleGoTodo('approval,execute,confirm')">全部待办 &gt;</a>
        </div>
        <div class="panel-body">
            <!-- 搜索栏 -->
            <div class="search-row">
                <a-input
                    v-model="globalSearchKey"
                    placeholder="搜索待办标题 / 发起人..."
                    allow-clear
                    @pressEnter="handleGlobalSearch"
                >
                    <a-icon slot="prefix" type="search" />
                </a-input>
                <a-button type="primary" :size="buttonSize" class="search-btn" @click="handleGlobalSearch">查询</a-button>
            </div>
            <!-- 统计卡片 -->
            <div class="stat-cards">
                <div class="stat-card stat-blue stat-clickable" @click="handleGoApprovalTask">
                    <div class="stat-top">
                        <span class="stat-name">待办事项</span>
<!--                        <span class="stat-en">ToDo</span>-->
                    </div>
                    <div class="stat-num"><span class="num">{{ statTodo }}</span><span class="unit">项</span></div>
                </div>
                <div class="stat-card stat-green stat-clickable" @click="handleGoNotify">
                    <div class="stat-top">
                        <span class="stat-name">待阅消息</span>
<!--                        <span class="stat-en">Message</span>-->
                    </div>
                    <div class="stat-num"><span class="num">{{ statMessage }}</span><span class="unit">条</span></div>
                </div>
                <div class="stat-card stat-red stat-clickable" @click="handleGoDone">
                    <div class="stat-top">
                        <span class="stat-name">已办事项</span>
<!--                        <span class="stat-en">Done</span>-->
                    </div>
                    <div class="stat-num"><span class="num">{{ statDone }}</span><span class="unit">项</span></div>
                </div>
                <div class="stat-card stat-orange stat-clickable" @click="handleGoTrack">
                    <div class="stat-top">
                        <span class="stat-name">跟踪事项</span>
<!--                        <span class="stat-en">Track</span>-->
                    </div>
                    <div class="stat-num"><span class="num">{{ statTrack }}</span><span class="unit">条</span></div>
                </div>
            </div>
            <!-- 待办列表 -->
            <div class="list-scroll-wrap">
                <a-list v-if="todoData.length" :data-source="todoData" class="todo-list-wrap">
                    <template slot="renderItem" slot-scope="item">
                        <a-list-item class="todo-list-item">
                            <div class="todo-title" :title="item.title" @click="handleTodoTitle(item)">{{ item.title }}</div>
                            <div class="todo-right-area">
                                <span class="handler-pill">{{ item.handlerName }}</span>
                                <span class="item-date">{{ item.dateText }}</span>
                            </div>
                        </a-list-item>
                    </template>
                </a-list>
                <a-empty v-else description="暂无待办事项" class="todo-list-wrap" />
            </div>
        </div>
        <Invitation :visible.sync="invitationVisible" :todo="currentTodo" @refresh="refreshData" />
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import {todoComplete, todoList} from "@/api/approval/todo";
import { fetchList as fetchMessageList } from "@/api/message";
import { fetchTask } from "@/api/approval";
import Invitation from "./Invitation.vue";

export default {
    name: 'TodoCenter',
    components: {
        Invitation
    },
    data() {
        return {
            invitationVisible: false,
            currentTodo: null,
            // 按钮尺寸（根据卡片宽度自适应）
            buttonSize: 'default',
            // 全局搜索
            globalSearchKey: '',
            filterStatusList: [],
            filterPriority: undefined,
            filterTitle: undefined,
            activeTodoTag: 'pending',
            todoData: [],
            todoTagOptions: [
                {value:'', name:'全部'},
                {value:'pending', name:'待处理'},
                {value:'processed', name:'已处理'},
                {value:'closed', name:'已关闭'},
            ],
            // 统计卡片数量
            statTodo: 0,
            statMessage: 0,
            statDone: 0,
            statTrack: 0,
        }
    },
    computed: {
        ...mapGetters("setting", ["findDataDict", "findSingleDictName"]),
        todoTabs() {
            return [{ key: 'all', label: '全部' }, ...(this.findDataDict("todoStatus") || []).map(item => ({ key: item.value, label: item.name }))];
        },
        tagOptions() {
            return [{ value: '', name: '全部' }, ...(this.findDataDict("todoTag") || [])];
        },
        priorityOptions() {
            return this.findDataDict("todoPriority") || [];
        }
    },
    mounted() {
        this.getList();
        this.getStats();
        this.setupResponsiveButtons();
    },
    beforeDestroy() {
        this.teardownResponsiveButtons();
    },
    methods: {
        ...mapMutations("tabs", ["setTabList"]),
        // 根据卡片实际宽度调整按钮尺寸
        updateButtonSize() {
            const el = this.$refs.rootEl;
            if (!el) return;
            const width = el.clientWidth;
            if (width >= 720) {
                this.buttonSize = 'large';
            } else if (width >= 460) {
                this.buttonSize = 'default';
            } else {
                this.buttonSize = 'small';
            }
        },
        setupResponsiveButtons() {
            this.updateButtonSize();
            if (typeof ResizeObserver !== 'undefined' && this.$refs.rootEl) {
                this._resizeObserver = new ResizeObserver(() => this.updateButtonSize());
                this._resizeObserver.observe(this.$refs.rootEl);
            } else {
                window.addEventListener('resize', this.updateButtonSize);
            }
        },
        teardownResponsiveButtons() {
            if (this._resizeObserver) {
                this._resizeObserver.disconnect();
                this._resizeObserver = null;
            }
            window.removeEventListener('resize', this.updateButtonSize);
        },
        // 全局搜索
        handleGlobalSearch(){
            this.getList();
        },
        // 列表与统计刷新
        refreshData(){
            this.getList();
            this.getStats();
        },
        // 跳转全部待办
        handleGoTodo(tags) {
            const path = '/todo';
            const tabList = [...this.$store.state.tabs.tabList];
            if (!tabList.some(t => t.path === path)) {
                tabList.push({ name: '待办事项', path, fullPath: path });
                this.setTabList(tabList);
            }
            const statusList = this.getTodoStatusListByTag(this.activeTodoTag);
            const query = { tags };
            if (statusList.length > 0) {
                query.statusList = statusList.join(',');
            }
            this.$router.push({ path, query });
        },
        // 跳转待阅消息
        handleGoNotify() {
            const path = '/approval/task';
            const tabList = [...this.$store.state.tabs.tabList];
            if (!tabList.some(t => t.path === path)) {
                tabList.push({ name: '审批中心', path, fullPath: path });
                this.setTabList(tabList);
            }
            this.$router.push({ path, query: { taskNotify: 'notify_task' } });
        },
        // 跳转审批中心待办
        handleGoApprovalTask() {
            const path = '/approval/task';
            const tabList = [...this.$store.state.tabs.tabList];
            if (!tabList.some(t => t.path === path)) {
                tabList.push({ name: '审批中心', path, fullPath: path });
                this.setTabList(tabList);
            }
            this.$router.push({ path });
        },
        // 跳转审批中心已办（默认选中 COMPLETED）
        handleGoDone() {
            const path = '/approval/task';
            const tabList = [...this.$store.state.tabs.tabList];
            if (!tabList.some(t => t.path === path)) {
                tabList.push({ name: '审批中心', path, fullPath: path });
                this.setTabList(tabList);
            }
            this.$router.push({ path, query: { activeKey: 'COMPLETED' } });
        },
        // 跳转全部跟踪
        handleGoTrack(){
            const path = '/todo';
            const tabList = [...this.$store.state.tabs.tabList];
            if (!tabList.some(t => t.path === path)) {
                tabList.push({ name: '待办事项', path, fullPath: path });
                this.setTabList(tabList);
            }
            this.$router.push({ path, query: { tags: 'track' } });
        },
        // 待办标签切换
        setTodoTag(tab) {
            this.activeTodoTag = tab.value;
            this.getList();
        },
        // 待办标签 -> statusList 映射
        getTodoStatusListByTag(tag) {
            const map = {
                pending: ['pending', 'processing', 'approving','not_started'],
                processed: ['completed','rejected'],
                closed: ['closed','overdue']
            };
            return map[tag] || [];
        },
        handleTodoTitle(item) {
            if (item.title && item.title.indexOf('请确认产值进度月报') > -1 && item.bizId) {
                const path = `/finance/progress-report/detail?reportId=${item.bizId}`;
                const basePath = `/finance/progress-report/detail`;
                const tabList = [...this.$store.state.tabs.tabList];
                if (!tabList.some(t => t.path === basePath)) {
                    tabList.push({ name: '产值进度月报详情', path: basePath, fullPath: path });
                    this.setTabList(tabList);
                }
                this.$router.push(path).catch(() => {});
                return;
            }
            if (item.tag === 'track' && item.source === 'approval_center' && item.bizId && item.bizSubId) {
                this.$router.push({
                    path: '/approval/task/detail',
                    query: {
                        taskId: item.bizSubId,
                        instanceId: item.bizId
                    }
                });
                return;
            }
            if (item.source === 'approval_center' && item.bizId) {
                const params = new URLSearchParams(item.bizId);
                const taskId = params.get('taskId');
                const instanceId = params.get('instanceId');
                if (taskId && instanceId) {
                    this.$router.push({
                        path: '/approval/task/detail',
                        query: {
                            taskId,
                            instanceId,
                            activeKey: item.status === 'completed' ? 'COMPLETED' : 'RUNNING'
                        }
                    });
                    return;
                }
            }
            if (item.source === 'supervision' && item.bizSubId) {
                this.$router.push({
                    path: '/oa/supervise/detail',
                    query: { id: item.bizSubId }
                });
                return;
            }
            if (item.title && item.title.startsWith('会后处理') && item.bizId) {
                const path = `/oa/meeting/handling?id=${item.bizId}`;
                const basePath = `/oa/meeting/handling`;
                const tabList = [...this.$store.state.tabs.tabList];
                if (!tabList.some(t => t.path === basePath)) {
                    tabList.push({ name: '会后处理', path: basePath, fullPath: path });
                    this.setTabList(tabList);
                }
                this.$router.push(path).catch(() => {});
                return;
            }
            if (item.source === 'meeting' && item.title && item.title.indexOf('归档会议') > -1 && item.bizId) {
                const path = `/oa/meeting/detail?id=${item.bizId}`;
                const basePath = `/oa/meeting/detail`;
                const tabList = [...this.$store.state.tabs.tabList];
                if (!tabList.some(t => t.path === basePath)) {
                    tabList.push({ name: '会议详情', path: basePath, fullPath: path });
                    this.setTabList(tabList);
                }
                this.$router.push(path).catch(() => {});
                todoComplete({
                    bizId: item.bizId,
                    bizSubId: item.bizSubId,
                    ignoreHandler: true,
                    status: 'completed'
                }).then(() => {
                    // this.$message.success('待办已处理');
                    this.getList(this.pageNum, this.pageSize);
                }).catch(() => {});
                return;
            }
            if (item.source === 'meeting' && (item.status === 'completed' || item.status === 'rejected' || item.status === 'closed') && item.bizId) {
                const path = `/oa/meeting/detail?id=${item.bizId}`;
                const basePath = `/oa/meeting/detail`;
                const tabList = [...this.$store.state.tabs.tabList];
                if (!tabList.some(t => t.path === basePath)) {
                    tabList.push({ name: '会议详情', path: basePath, fullPath: path });
                    this.setTabList(tabList);
                }
                this.$router.push(path).catch(() => {});
                return;
            }
            this.currentTodo = item;
            this.invitationVisible = true;
        },
        // 获取待办列表
        getList() {
            const tagStatusList = this.getTodoStatusListByTag(this.activeTodoTag);
            const params = {
                pageNum : 1,
                pageSize : 20,
                title: this.globalSearchKey || undefined,
                tags: ['approval', 'execute', 'confirm','track'],
                statusList: tagStatusList.length > 0 ? tagStatusList : (this.filterStatusList.length > 0 ? this.filterStatusList.filter(s => s !== 'all') : undefined)
            };
            todoList(params).then(res => {
                if (!Array.isArray(res.list)) return;
                this.todoData = res.list.map(item => {
                    return {
                        ...item,
                        title: item.title || item.content || '',
                        handlerName: item.handlerName || '',
                        dateText: this.formatMonthDay(item.deadlineDate || item.createAt)
                    };
                });
            });
        },
        // 统计卡片数量
        getStats() {
            fetchTask({ pageNum: 0, pageSize: 1,status:"RUNNING" }).then(res => {
                this.statTodo = res.totalSize || 0;
            });
            fetchTask({ pageNum: 0, pageSize: 1,status:"COMPLETED" }).then(res => {
                this.statDone = res.totalSize || 0;
            });
            // todoList({
            //     pageNum: 1,
            //     pageSize: 1,
            //     tags: ['approval', 'execute', 'confirm'],
            //     statusList: ['completed', 'rejected']
            // }).then(res => {
            //     this.statDone = res.totalSize || 0;
            // });
            todoList({
                pageNum: 1,
                pageSize: 1,
                tags: ['track'],
                statusList: ['approving', 'processing', 'pending', 'not_started']
            }).then(res => {
                this.statTrack = res.totalSize || 0;
            });
            fetchMessageList({ pageNum: 1, pageSize: 1, isRead: 0 }).then(res => {
                this.statMessage = res.totalSize || 0;
            });
        },
        formatMonthDay(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return dateStr;
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            return `${m}-${d}`;
        }
    }
}
</script>

<style scoped>
.approval-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    height: 40vh;
    display: flex;
    flex-direction: column;
}
.panel-header {
    display: flex;
    align-items: center;
    gap: 16px;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 12px;
}
.panel-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    padding-left: 12px;
    position: relative;
    flex-shrink: 0;
}
.panel-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 20px;
    background-color: #2563eb;
}
.header-tabs {
    display: flex;
    gap: 8px;
}
.text-link {
    margin-left: auto;
    color: #2563eb;
    cursor: pointer;
    text-decoration: none;
    flex-shrink: 0;
}
.text-link:hover {
    color: #1d4ed8;
}
.panel-body {
    flex: 1;
    min-height: 0;
    padding: 12px 0 0;
    display: flex;
    flex-direction: column;
}
/* 搜索栏 */
.search-row {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
}
.search-row ::v-deep .ant-input {
    border-radius: 18px;
}
.search-btn {
    border-radius: 18px;
    padding: 0 22px;
}
.search-btn.ant-btn-sm {
    padding: 0 14px;
    height: 30px;
}
.search-btn.ant-btn-lg {
    padding: 0 30px;
}
/* 统计卡片 */
.stat-cards {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
}
.stat-card {
    flex: 1;
    border-radius: 12px;
    padding: 12px 16px;
    color: #fff;
    min-width: 0;
    position: relative;
    isolation: isolate;
    overflow: hidden;
}
.stat-blue {
    background: linear-gradient(135deg, #5b9bff 0%, #2563eb 100%);
}
.stat-green {
    background: linear-gradient(135deg, #3dd6a3 0%, #0ea5a5 100%);
}
.stat-red {
    background: linear-gradient(135deg, #ff8f8f 0%, #ef4444 100%);
}
.stat-orange {
    background: linear-gradient(135deg, #ffc53d 0%, #f59e0b 100%);
}
.stat-clickable {
    cursor: pointer;
}
.stat-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.stat-name {
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}
.stat-en {
    position: absolute;
    /*right: 10px;*/
    bottom: 4px;
    z-index: -1;
    font-size: 36px;
    font-weight: 700;
    line-height: 1;
    color: rgba(255, 255, 255, .2);
    white-space: nowrap;
    pointer-events: none;
}
.stat-num {
    margin-top: 6px;
    display: flex;
    align-items: baseline;
    gap: 4px;
}
.stat-num .num {
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
}
.stat-num .unit {
    font-size: 10px;
    opacity: .9;
}
/* 待办列表 */
.list-scroll-wrap {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    max-height: 230px;
    min-width: 0;
    /* 默认隐藏滚动条，悬停显示 */
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
}
.list-scroll-wrap:hover {
    scrollbar-color: #d1d5db transparent;
}
.list-scroll-wrap::-webkit-scrollbar {
    width: 6px;
}
.list-scroll-wrap::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 3px;
}
.list-scroll-wrap:hover::-webkit-scrollbar-thumb {
    background: #d1d5db;
}
::v-deep .todo-list-wrap .ant-list-item {
    border-bottom: 0;
    /*padding: 0 !important;*/
    margin-bottom: 3px !important;
}
.todo-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-width: 0;
    background: #f7f9fc;
    border-radius: 8px;
    padding: 7px 12px;
}
.todo-list-item:hover {
    background: #eef4ff;
}
.todo-title {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    color: #333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
}
.todo-title:hover {
    color: #2563eb;
}
.todo-right-area {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}
.handler-pill {
    background: #e6f0ff;
    color: #2563eb;
    border-radius: 12px;
    font-size: 12px;
    padding: 2px 10px;
    max-width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.item-date {
    color: #999;
    font-size: 12px;
}
</style>
